<div class="layout">
  <app-header></app-header>

  <app-navbar></app-navbar>

  <div class="layout__content">
    @if (!isIframe) {
      <router-outlet></router-outlet>
      <router-outlet name="download"></router-outlet>
    }
  </div>

  <app-footer></app-footer>
</div>
